import React from 'react';
import { 
  HelpCircle, 
  Thermometer, 
  Wind, 
  Home, 
  Droplets, 
  Sun, 
  Snowflake,
  Lightbulb
} from 'lucide-react';

const TipsSidebar = () => {
  const tips = [
    {
      icon: Home,
      title: 'Теплоизоляция стен',
      description: 'Качественное утепление стен может сократить теплопотери на 20-35%. Рекомендуемая толщина утеплителя в средней полосе России 100-150 мм.'
    },
    {
      icon: Droplets,
      title: 'Современные окна',
      description: 'Замена старых окон на современные энергосберегающие с двойным или тройным остеклением снизит потери тепла до 50% через оконные проемы.'
    },
    {
      icon: Wind,
      title: 'Система вентиляции',
      description: 'Установка системы вентиляции с рекуперацией тепла позволяет сохранить до 85% тепловой энергии при воздухообмене.'
    },
    {
      icon: Snowflake,
      title: 'Утепление крыши',
      description: 'Через неутепленную крышу может уходить до 25% тепла. Оптимальная толщина утеплителя 200-300 мм.'
    },
    {
      icon: Thermometer,
      title: 'Тепловые мосты',
      description: 'Устранение тепловых мостов (мест с повышенной теплопроводностью) может снизить общие теплопотери на 5-15%.'
    },
    {
      icon: Sun,
      title: 'Ориентация здания',
      description: 'Правильная ориентация окон на юг позволяет использовать пассивное солнечное отопление и сократить затраты на обогрев.'
    },
    {
      icon: Lightbulb,
      title: 'Энергоэффективное отопление',
      description: 'Современные системы отопления (тепловые насосы, конденсационные котлы) могут быть на 25-40% эффективнее традиционных.'
    }
  ];

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <HelpCircle className="w-5 h-5 mr-2 text-red-500" />
        Советы по снижению теплопотерь
      </h3>

      <div className="space-y-3">
        {tips.map((tip, index) => (
          <div 
            key={index} 
            className="flex items-start space-x-3 p-3 bg-gray-50 dark:bg-gray-700/30 rounded-lg border border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            <tip.icon className="w-5 h-5 text-red-500 mt-1 flex-shrink-0" />
            <div>
              <h4 className="text-sm font-medium text-gray-900 dark:text-white mb-1">
                {tip.title}
              </h4>
              <p className="text-xs text-gray-600 dark:text-gray-400">
                {tip.description}
              </p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-red-50 dark:bg-red-900/20 border border-red-100 dark:border-red-800 rounded-lg">
        <div className="flex items-start space-x-3">
          <HelpCircle className="w-5 h-5 text-red-500 mt-1 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-semibold text-red-700 dark:text-red-300 mb-2">
              Получите комплексный аудит теплопотерь
            </h4>
            <p className="text-xs text-red-600 dark:text-red-400 mb-3">
              Для точной оценки теплопотерь дома рекомендуется заказать тепловизионное обследование у специалистов.
            </p>
            <button className="w-full py-1.5 text-xs bg-red-500 text-white rounded hover:bg-red-600 transition-colors">
              Найти специалиста в вашем регионе
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TipsSidebar;